import { isDashboardOrgSegment, readDashboardOrgCookie } from "@/lib/dashboardOrg";
import { peekAgentsOrgContext } from "@/lib/ensureAgentsOrgContext";

/** Same org key One and Agents use for KB registry localStorage + cookie sync. */
export function resolveKnowledgeOrgId(
  sessionOrgId: string | null | undefined,
  agentsOrgId?: string | null,
): string | null {
  const fromSession = (sessionOrgId || "").trim();
  if (isDashboardOrgSegment(fromSession)) return fromSession;
  const fromCtx = peekAgentsOrgContext()?.orgId;
  if (fromCtx) return fromCtx;
  const fromCookie = readDashboardOrgCookie();
  if (fromCookie) return fromCookie;
  const fromAgents = (agentsOrgId || "").trim();
  if (isDashboardOrgSegment(fromAgents)) return fromAgents;
  return null;
}
